import { render, staticRenderFns } from "./PlayerWalletsHistory.vue?vue&type=template&id=cd23fd3a&"
import script from "./PlayerWalletsHistory.vue?vue&type=script&lang=js&"
export * from "./PlayerWalletsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports